<div>
  <div>
    <button pButton class="returnButton p-button-info" label="{{ 'VIRTUAL_PRINTER.COMMON.RETURN' | translate }}" (click)="unsetDisplayFormToDownload( $event )" icon="fa fa-arrow-circle-left"></button>
  </div>
    <p-fieldset id="download_generic-version" legend="{{ 'VIRTUAL_PRINTER.COMMON.VERSION' | translate }} : {{ this.releaseValue }}">
      <p-fieldset [styleClass]="'fieldset'"  id="download_generic-context" legend="{{ 'VIRTUAL_PRINTER.COMMON.CONTEXT' | translate }}">
        <div class="grid fichiers">
          <div class="col-3">
            <label for="arch"> {{ 'VIRTUAL_PRINTER.COMMON.ARCHITECTURE' | translate }} : </label>
          </div>
          <div class="col-3" style="text-align: left">
            <p-dropdown id="arch" name="arch" [ngModel]="arch" [options]="archList" (onChange)="setArch($event)"></p-dropdown>
          </div>
          <div class="col-3">
            <label for="env"> {{ 'VIRTUAL_PRINTER.COMMON.ENVIRONMENT' | translate }} : </label>
          </div>
          <div class="col-3" style="text-align: left">
            <p-dropdown id="env" name="env" [ngModel]="env" [options]="this.envList" (onChange)="setEnv($event)"></p-dropdown>
          </div>
        </div>
      </p-fieldset>
      <p-fieldset id="download_generic-parameters" [styleClass]="'fieldset'" legend="{{ 'VIRTUAL_PRINTER.DOWNLOAD_COMPONENT.GENERIC_LEGEND' | translate }}">
        <div>
          <div class="grid fichiers">
            <div class="col-3">
              <label for="locale"> {{ 'VIRTUAL_PRINTER.COMMON.LANGAGE' | translate }} : </label>
            </div>
            <div class="col-2">
              <p-dropdown id="locale" name="locale" [ngModel]="locale" [options]="this.localeList" (onChange)="setLocale($event)"></p-dropdown>
            </div>
            <div class="col-1"></div>
            <div class="col-3">
              <label for="uploadFormat"> {{ 'VIRTUAL_PRINTER.DOWNLOAD_COMPONENT.UPLOAD_FORMAT' | translate }} : </label>
            </div>
            <div class="col-3">
              <p-dropdown id="uploadFormat" name="uploadFormat" [ngModel]="uploadFormat" [options]="this.uploadFormatList" (onChange)="setUploadFormat($event)"></p-dropdown>
            </div>
          </div>
          <div class="grid fichiers">
            <div class="col-3">
              <label for="serverMode"> {{ 'VIRTUAL_PRINTER.DOWNLOAD_COMPONENT.SERVER_MODE' | translate }} :  </label>
            </div>
            <div class="col-2">
              <p-inputSwitch id="serverMode" [(ngModel)]="serverMode" name="serverMode"></p-inputSwitch>
            </div>
            <div class="col-1"></div>
            <div class="col-3">
              <label for="displayPDF"> {{ 'VIRTUAL_PRINTER.DOWNLOAD_COMPONENT.DISPLAY_PDF' | translate }} :  </label>
            </div>
            <div class="col-3">
              <p-inputSwitch id="displayPDF" [(ngModel)]="displayPDF" name="displayPDF"></p-inputSwitch>
            </div>
          </div>
          <div class="grid fichiers">
            <div class="col-3">
              <label for="showSelectChain"> {{ 'VIRTUAL_PRINTER.DOWNLOAD_COMPONENT.DISPLAY_CHAIN' | translate }} :  </label>
            </div>
            <div class="col-2">
              <p-inputSwitch id="showSelectChain" [(ngModel)]="showSelectChain" name="showSelectChain"></p-inputSwitch>
            </div>
            <div class="col-1"></div>
            <div class="col-3">
              <label for="showSelectDistriMode"> {{ 'VIRTUAL_PRINTER.DOWNLOAD_COMPONENT.UPLOAD_DISTRI_METHOD' | translate }} :  </label>
            </div>
            <div class="col-2">
              <p-inputSwitch id="showSelectDistriMode" [(ngModel)]="showSelectDistriMode" name="showSelectDistriMode"></p-inputSwitch>
            </div>
          </div>
       </div>
    </p-fieldset>
      <p-fieldset id="download_generic-proxy" [styleClass]="'fieldset'" class="fieldset"  legend="Proxy">
        <div class="grid fichiers">
          <div class="col-3">
            <label for="useProxy"> {{ 'VIRTUAL_PRINTER.DOWNLOAD_COMPONENT.USE_PROXY' | translate }} : </label>
          </div>
          <div class="col-2">
            <p-inputSwitch id="useProxy" [(ngModel)]="useProxy" name="useProxy"></p-inputSwitch>
          </div>
          <div class="col-7" >
            <p-selectButton *ngIf="this.useProxy" [options]="proxyTypes" [(ngModel)]="proxyType" (onChange)="initErrorMessages()" name="proxyType"></p-selectButton>
          </div>
        </div>
        <ng-template [ngIf]="this.useProxy">
          <div *ngIf="this.proxyType === 'statique'" class="grid fichiers">
            <div class="col-3">
              <label for="useProxy"> {{ 'VIRTUAL_PRINTER.DOWNLOAD_COMPONENT.PAC_URL' | translate }} : </label>
            </div>
            <div class="col-9">
              <input pInputText id="proxyPAC" name="proxyPAC" [(ngModel)]="proxyPAC" (input)="checkRegExp( $event, 'pac_format_error', this.regexp.get( 'url' ));" placeholder="{{ 'VIRTUAL_PRINTER.DOWNLOAD_COMPONENT.PAC_URL_PLACEHOLDER' | translate }}"/>
            </div>
          </div>
          <div *ngIf="this.proxyType === 'dynamique'" class="grid fichiers">
            <div class="col-1">
              <label for="proxyHost"> {{ 'VIRTUAL_PRINTER.DOWNLOAD_COMPONENT.HOST' | translate }} : </label>
            </div>
            <div class="col-5">
              <input pInputText id="proxyHost" name="proxyHost" [(ngModel)]="proxyHost" (input)="checkHostNameFormat( $event );" placeholder="{{ 'VIRTUAL_PRINTER.DOWNLOAD_COMPONENT.PROXY_URL' | translate }} " />
            </div>
            <div class="col-1">
              <label for="proxyPort"> {{ 'VIRTUAL_PRINTER.DOWNLOAD_COMPONENT.PORT' | translate }} : </label>
            </div>
            <div class="col-5">
              <input pInputText id="proxyPort" name="proxyPort" [(ngModel)]="proxyPort" (input)="HostProxyChange();  checkRegExp( $event, 'port_format_error', this.regexp.get( 'number' ) )" placeholder="{{ 'VIRTUAL_PRINTER.DOWNLOAD_COMPONENT.PROXY_PORT_PLACEHOLDER' | translate }}" />
            </div>
          </div>
          <div class="grid fichiers">
            <div class="col-3">
              <label for="proxyAuth"> {{ 'VIRTUAL_PRINTER.DOWNLOAD_COMPONENT.AUTHENTICATION' | translate }} : </label>
            </div>
            <div class="col-9">
              <p-inputSwitch id="proxyAuth" [(ngModel)]="proxyAuth" name="proxyAuth"></p-inputSwitch>
            </div>
          </div>
          <ng-container *ngIf="this.proxyAuth">
            <div class="grid fichiers">
              <div class="col-3">
                <label for="proxyUserName"> {{ 'VIRTUAL_PRINTER.DOWNLOAD_COMPONENT.LOGIN' | translate }} : </label>
              </div>
              <div class="col-9">
                <input pInputText id="proxyUserName" name="proxyUserName" [(ngModel)]="proxyUserName" (input)="loginPassword( $event )" placeholder="{{ 'VIRTUAL_PRINTER.DOWNLOAD_COMPONENT.LOGIN_PLACEHOLDER' | translate }} " />
              </div>
            </div>
            <div class="grid fichiers">
              <div class="col-3">
                <label for="proxyUserPassword"> {{ 'VIRTUAL_PRINTER.DOWNLOAD_COMPONENT.PASSWORD' | translate }} : </label>
              </div>
              <div class="col-9">
                <input pInputText id="proxyUserPassword" name="proxyUserPassword" [(ngModel)]="proxyUserPassword" (input)="loginPassword( $event )" placeholder="{{ 'VIRTUAL_PRINTER.DOWNLOAD_COMPONENT.PASSWORD_PLACEHOLDER' | translate }} " />
              </div>
            </div>
          </ng-container>
        </ng-template>
      </p-fieldset>
  <div>
  </div>
      <p-fieldset id="displayErrors" legend="{{ 'VIRTUAL_PRINTER.COMMON.PROBLEMS' | translate }} :">
        <ul id="upload_package_error_list">
          <ng-container *ngFor="let error of this.downloadGenericMessages.errors">
            <li *ngIf="error.active"> {{ error.message }} </li>
          </ng-container>
        </ul>
        <p *ngIf="this.downloadGenericMessages.success.active" >
          <span> {{ this.downloadGenericMessages.success.message }}</span>
        </p>
      </p-fieldset>
    </p-fieldset>
    <div>
      <input pButton id="submitDownloadGenericVirtualPrinter" class="button p-button-success" type="button" value="{{ 'VIRTUAL_PRINTER.COMMON.DOWNLOAD_VERB' | translate }}" (click)="downloadGenericVirtualPrinter($event)" [disabled]="!this.downloadGenericMessages.success.active" />
      <input pButton id="resetDownloadGenericVirtualPrinter" type="reset" class="button p-button-info" value="{{ 'VIRTUAL_PRINTER.COMMON.CANCEL' | translate }}" (click)="resetDownloadGenericVirtualPrinter( $event )" />
    </div>
    <div class="clear"></div>
</div>
